import '.br{flex-shrink:0;}.ssr-plugin'
import '.bs{width:20rem;}.ssr-plugin'
import '.ak{border:var(--blue-border);}.ssr-plugin'
import '.be{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.bt{padding:1rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{gap:2rem;}.ssr-plugin'
import '.bu{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="br bs ak be ad bt"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="a d bu"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
